var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Sorts payment rows first by paymentDate in ascending order and then by aid target number in
 * ascending order. Null cases appear at the start of the list.
 * */
export function futurePaymentSorter(a, b) {
    if (a.paymentDate === null && b.paymentDate !== null)
        return -1;
    if (a.paymentDate !== null && b.paymentDate === null)
        return 1;
    if (a.paymentDate !== null && b.paymentDate !== null) {
        if (a.paymentDate < b.paymentDate)
            return -1;
        if (a.paymentDate > b.paymentDate)
            return 1;
    }
    return aidTargetSorter(a.aidTargetNumber, b.aidTargetNumber);
}
/**
 * Sorts payment rows first by paidDate in descending order and then by aid target number in
 * ascending order. Null cases appear at the end of the list.
 * */
export function historyPaymentSorter(a, b) {
    if (a.dateLocal === null && b.dateLocal !== null)
        return 1;
    if (a.dateLocal !== null && b.dateLocal === null)
        return -1;
    if (a.dateLocal !== null && b.dateLocal !== null) {
        if (a.dateLocal < b.dateLocal)
            return 1;
        if (a.dateLocal > b.dateLocal)
            return -1;
    }
    return aidTargetSorter(a.aidTargetNumber, b.aidTargetNumber);
}
export function byTargetSorter(a, b) {
    return aidTargetSorter(a.aidTargetNumber, b.aidTargetNumber);
}
/**
 * Sorts payment rows by aid target number in ascending order.
 * */
function aidTargetSorter(a, b) {
    if (a === null && b === null)
        return 0;
    if (a === null && b !== null)
        return -1;
    if (a !== null && b === null)
        return 1;
    var _a = __read(a.split(/\s{1}/), 2), acPart = _a[0], anPart = _a[1];
    var _b = __read(b.split(/\s{1}/), 2), bcPart = _b[0], bnPart = _b[1];
    if (acPart < bcPart)
        return -1;
    if (acPart > bcPart)
        return 1;
    if (!anPart && !bnPart)
        return 0;
    if (!anPart && bnPart)
        return -1;
    if (anPart && !bnPart)
        return 1;
    return Number(anPart) - Number(bnPart);
}
